import {
  IShopAuthUser,
  IShopCreateUserAddressInput,
  IShopDeleteUserAddressInput,
  IShopUpdateUserAddressInput,
  IShopUpdateUserMutationInput,
  IShopUserLoginVariables,
  IShopUserRegistrationVariables,
  TShopUserDeclarationMutationVariables,
} from '@x/ecommerce/shop-client';
import { ArchiveUserPaymentMethodInput } from '@x/schemas/ecommerce';

export class AuthRegister {
  static readonly type = '[Auth] Register';
  constructor(public input: IShopUserRegistrationVariables) {}
}

export class AuthLogin {
  static readonly type = '[Auth] Login';
  constructor(public input: IShopUserLoginVariables) {}
}

export class AuthLogout {
  static readonly type = '[Auth] Logout';
}

export class AuthUser {
  static readonly type = '[Auth] Authenticate';
}

export class AuthSetUser {
  static readonly type = '[Auth] Set user';
  constructor(public user: IShopAuthUser) {}
}

export class AuthUpdateUser {
  static readonly type = '[Auth] Update user';
  constructor(public input?: IShopUpdateUserMutationInput) {}
}

export class AuthCreateUserAddress {
  static readonly type = '[Auth] Create user address';
  constructor(public input: IShopCreateUserAddressInput) {}
}

export class AuthUpdateUserAddress {
  static readonly type = '[Auth] Update user address';
  constructor(public input: IShopUpdateUserAddressInput) {}
}

export class AuthDeleteUserAddress {
  static readonly type = '[Auth] Delete user address';
  constructor(public input: IShopDeleteUserAddressInput) {}
}

export class AuthUpdatePassword {
  static readonly type = '[Auth] Update user password';
  constructor(public password: string) {}
}

export class AuthUpdateArchiveUserPaymentMethod {
  static readonly type = '[Auth] Archive user payment method';
  constructor(public input: ArchiveUserPaymentMethodInput) {}
}

export class AuthRefreshUserPaymentMethods {
  static readonly type = '[Auth] Refresh user payment methods';
}

export class AuthGetUserAddresses {
  static readonly type = '[Auth] Auth Get User Addresses';
}

export class AuthRefreshUserAddresses {
  static readonly type = '[Auth] Auth Refresh User Addresses';
}

export class AuthUpdateUserDeclaration {
  static readonly type = '[Auth] Update required agreements';
  constructor(public args: TShopUserDeclarationMutationVariables['input']) {}
}
